module.exports = __webpack_public_path__ + "img/0Q3A2361_FoamcoreMatted.150a3d72.jpg";